import { FieldValues, FormState, Path } from 'react-hook-form';
import { UseFieldDeps } from '../type';

export type FieldContext<TValues extends FieldValues = FieldValues> = {
    values: TValues;
    get: <TPath extends Path<TValues>>(path: TPath) => any;
    formState: FormState<TValues>;
};

export function useFieldContext<TValues extends FieldValues = FieldValues>(
    form: UseFieldDeps<TValues>,
): FieldContext<TValues> {
    const { getValues, formState } = form;

    const values = getValues() as TValues;

    return {
        values: getValues(),
        get: (path) => (values as any)?.[path] ?? (getValues() as any)?.[path],
        formState,
    };
}
